// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37qMQ","col":"styles_col__W4HbM","actions":"styles_actions__SCfdq","conflict":"styles_conflict__IJObI"};